import { translate } from './translate';

export function minutesToText(minutes: number | null, options?: { longFormat?: boolean; }) {
    const hourPrefix = options?.longFormat ? translate('hour') : 'h';
    const hoursPrefix = options?.longFormat ? translate('hours') : 'h';
    const minutesPrefix = options?.longFormat ? translate('minutes') : 'min';

    if (minutes) {
        let response = '';
        const hours = Math.floor(minutes / 60);
        if (hours) {
            if (options?.longFormat) {
                response = hours == 1 ? `${hours} ${hourPrefix}` : `${hours} ${hoursPrefix}`;
            } else {
                response = hours == 1 ? `${hours}${hourPrefix}` : `${hours}${hoursPrefix}`;
            }
        }

        const remainMinutes = minutes % 60;
        if (remainMinutes) {
            if (options?.longFormat) {
                if (hours) {
                    response = response + ' ' + translate('and') + ' ';
                }
                response = response + `${remainMinutes} ${minutesPrefix}`;
            } else {
                response = response + `${remainMinutes}${minutesPrefix}`;
            }
        }

        return response;
    }

    return translate('undefined');
}

export function minutesToHourFormat(minutes: number | null) {
    if (minutes) {
        let response = '';
        const hours = Math.floor(minutes / 60);
        if (hours) {
            response = `${hours}:`;
        } else {
            response = '00:';
        }

        const remainMinutes = minutes % 60;
        if (remainMinutes) {
            response = response + `${remainMinutes}`;
        } else {
            response = response + '00';
        }

        return response;
    }
    return '';
}

export function textToMinutes(text: string) {
    if (text.length) {
        const hours = Number(text.split(':')[0]);
        const minutes = Number(text.split(':')[1]);

        return hours * 60 + minutes;
    }

    return null;
}
